// Probably move this file to backend...

import {
  TKycEmploymentType,
  TKycOccupationType
} from '@sparbanken-syd/borgo-types'
import {SPBConstants} from '@sparbanken-syd/sparbanken-syd-theme'


// List of occupation types that are ALLOWED to be used in the application.
// These are the ONLY occupation types that will be marked as available.
export const allowedOccupationFields: TKycOccupationType[] = ['EMPLOYEE', 'SELF_EMPLOYED', 'STUDENT', 'PENSIONER', 'JOB_SEEKER']

// List of employment types that are ALLOWED to be used in the application.
// These are the ONLY employment types that will be marked as available.
export const allowedFormOfEmploymentFields: TKycEmploymentType[] = ['PERMANENT', 'FIXED_TERM']

export interface ICountrySimple {
  name: string
  code: string
}

const simpleCountryList: ICountrySimple[] = SPBConstants.CountryList.map(country => ({
  name: country.name,
  code: country[2]
}))

// Sort with Sverige first and the others by name
export const swedenCountyList = simpleCountryList
  .toSorted((a, b) => {
    if (a.name === 'Sverige') return -1
    if (b.name === 'Sverige') return 1
    return a.name.localeCompare(b.name)
  })

export const sortedCountryList = simpleCountryList
  .toSorted((a, b) => a.name.localeCompare(b.name))


export const countryCodes = [
  '46', // Sverige
  '45', // Danmark
  '47', // Norge
  '358', // Finland
  '354', // Island

  '1', // Förenta staterna (USA) & Kanada
  '44', // Storbritannien
  '49', // Tyskland
  '33', // Frankrike
  '39', // Italien
  '34', // Spanien
  '351', // Portugal
  '353', // Irland
  '352', // Luxemburg
  '31', // Nederländerna
  '32', // Belgien
  '41', // Schweiz
  '43', // Österrike
  '30', // Grekland
  '48', // Polen
  '420', // Tjeckien
  '421', // Slovakien
  '36', // Ungern
  '386', // Slovenien
  '385', // Kroatien
  '381', // Serbien
  '359', // Bulgarien
  '355', // Albanien
  '383', // Kosovo
  '382', // Montenegro
  '389', // Nordmakedonien
  '40', // Rumänien
  '380', // Ukraina
  '375', // Belarus/Vitryssland
  '7', // Ryssland

  '378', // San Marino
  '379', // Vatikanstaten
  '423', // Liechtenstein
  '500', // Falklandsöarna
  '508', // Saint-Pierre och Miquelon

  '81', // Japan
  '86', // Kina
  '82', // Sydkorea
  '91', // Indien
  '61', // Australien
  '64', // Nya Zeeland
  '27', // Sydafrika
  '52', // Mexiko
  '55', // Brasilien
  '54', // Argentina
  '56', // Chile
  '57', // Colombia
  '58', // Venezuela
  '51', // Peru
  '593', // Ecuador
  '595', // Paraguay
  '598', // Uruguay
  '591', // Bolivia

  '20', // Egypten
  '212', // Marocko
  '216', // Tunisien
  '213', // Algeriet
  '249', // Sudan
  '251', // Etiopien
  '254', // Kenya
  '256', // Uganda
  '250', // Rwanda
  '255', // Tanzania
  '260', // Zambia
  '263', // Zimbabwe
  '234', // Nigeria
  '233', // Ghana
  '225', // Elfenbenskusten
  '221', // Senegal

  '236', // Centralafrikanska republiken
  '237', // Kamerun
  '239', // São Tomé och Príncipe
  '243', // Demokratiska republiken Kongo
  '268', // Eswatini (Swaziland)
  '220', // Gambia
  '228', // Togo
  '265', // Malawi
  '266', // Lesotho
  '267', // Botswana
  '269', // Komorerna

  '971', // Förenade Arabemiraten
  '966', // Saudiarabien
  '974', // Qatar
  '973', // Bahrain
  '968', // Oman
  '965', // Kuwait
  '972', // Israel
  '961', // Libanon
  '962', // Jordanien
  '964', // Irak
  '98', // Iran
  '92', // Pakistan
  '880', // Bangladesh
  '94', // Sri Lanka
  '977', // Nepal
  '95', // Myanmar
  '855', // Kambodja
  '856', // Laos
  '84', // Vietnam
  '66', // Thailand
  '62', // Indonesien
  '63', // Filippinerna
  '60', // Malaysia
  '65', // Singapore
  '886', // Taiwan
  '852', // Hongkong
  '853', // Macao
  '976', // Mongoliet
  '975', // Bhutan
  '960', // Maldiverna
  '670', // Östtimor

  '692', // Marshallöarna
  '679', // Fiji
  '686', // Kiribati
  '681', // Wallis- och Futunaöarna
  '683', // Niue
  '685', // Samoa
  '687', // Nya Kaledonien
  '689', // Franska Polynesien
  '691', // Mikronesien

  '599', // Karibiska Nederländerna
  '1268', // Antigua och Barbuda
  '1242', // Bahamas
  '1246', // Barbados
  '1441', // Bermuda
  '1284', // Brittiska Jungfruöarna
  '1345', // Caymanöarna
  '1767', // Dominica
  '1809', '1829', '1849', // Dominikanska republiken
  '1473', // Grenada
  '1876', '1658', // Jamaica
  '1664', // Montserrat
  '1869', // Saint Kitts och Nevis
  '1758', // Saint Lucia
  '1721', // Sint Maarten
  '1868', // Trinidad och Tobago
  '1649', // Turks- och Caicosöarna
  '1784' // Saint Vincent och Grenadinerna
]
